/**
 * <EditPageOnSideMenu 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale';
import './EditPageOnSideMenu.scss';

class EditPageOnSideMenu extends React.Component {
  constructor(props) {
    super(props);
  
    this.addPage = this.addPage.bind(this);
    this.editPage = this.editPage.bind(this);
    this.onCurrentPageChange = this.onCurrentPageChange.bind(this);
  }

  componentWillMount() {

  }

  addPage() {
    this.props.onStartEdit({
      title: '',
    });
  }

  onCurrentPageChange(page) {
    return()=>{
      if (page && page.page_setting && typeof page.page_setting.slug !== "undefined") {
        this.props.onChange(page.page_setting.slug);
      }
    }
  }

  editPage(page) {
    return ()=>{
      this.props.onStartEdit(page);
    }
  }
  
  render() {
    const {
      pages = [],
      page = {},
      site,
    } = this.props;

    return (
      <div className='EditPageOnSideMenu'>
        <div className='EditPageOnSideMenu--menu'>
          <span>{__('Active Pages', locale)}</span>
          <i className='fa icon-plus addPage' onClick={this.addPage}></i>
        </div>
        <ul className='EditPageOnSideMenu--pageList activePages'>
          {Object.keys(pages).map((key, index)=>{
            const thisPage = pages[key];
            const {
              title,
              id,
            } = thisPage;

            const active = id == page.id ? 'active' : '';

            return (
              <li className={classnames('EditPageOnSideMenu--page', { active })} key={index} onClick={this.onCurrentPageChange(thisPage)} >
                <div className='content'>
                  {title}
                  <i className='fa icon-cog editPage' onClick={this.addPage} onClick={this.editPage(thisPage)}></i>
                </div>
              </li>
            );
          })}
        </ul>
        <div className='EditPageOnSideMenu--menu'>
          <span>{__('Inactive Pages', locale)}</span>
          <i className='fa icon-plus addPage' onClick={this.addPage} onClick={this.addPage}></i>
        </div>
        <ul className='EditPageOnSideMenu--pageList'>
           
        </ul>
      </div>
    )
  }
}

export default EditPageOnSideMenu;



// WEBPACK FOOTER //
// ./src/containers/pages/Website/EditPageOnSideMenu/index.js